var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-md-2"},[_c('transportation-options',{attrs:{"value":"261"},on:{"onChange":_vm.onOptionChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }